import axios from 'axios';
import { loadError } from "../../../forms/inputValidationUtils/load_error.js";
import React from 'react';

export function saveUserRequest(dbUrl, dbHeaders, userRequestDetails, handleSaveFinish) {
    let options = {};
    return new Promise(resolve => {
        let userDisplayName = userRequestDetails.first_name + " " + userRequestDetails.last_name
        axios.post(dbUrl + `user-access-request/`, userRequestDetails, dbHeaders)
            .then(res => {
                options = {
                    position: "top-right",
                    message: "Request For " + userDisplayName + " Created",
                    type: "info",
                    icon: <i className={"animo-icons icon-verified"} />,
                    autoClose: 5000
                };
                handleSaveFinish(options, true, false)
                resolve(res.data.id)

            })
            .catch(error => {
                options = loadError(error)
                handleSaveFinish(options, false, true)
                resolve(null)
            })
    })
}

export function updateUserActiveJob(dbUrl, dbHeaders, activeJobDetails, userId, source) {
    let options = {};
    return new Promise(resolve => {
        let inValidUrl = dbUrl ? dbUrl.includes("admin") : true
        if (userId && !inValidUrl) {
            axios.patch(dbUrl + `personnel/${userId}/`, activeJobDetails, dbHeaders)
                .catch(error => {
                    options = loadError(error)
                    resolve(null)
                })
        }
        if (userId && !inValidUrl) {
            axios.get(dbUrl + `person-meta-data/?person=${userId}&fields=id`, dbHeaders)
                .then(res => {
                    if (res.data[0].id) {
                        axios.patch(dbUrl + `person-meta-data/${res.data[0].id}/`, activeJobDetails, dbHeaders)
                            .then(res => {
                                resolve(res.data.id)
                            })
                            .catch(error => {
                                options = loadError(error)
                                resolve(null)
                            })
                    }
                })
        }
    })
}
export function updateUser(dbUrl, dbHeaders, userDetails, userId) {
    let options = {};
    return new Promise(resolve => {
        let inValidUrl = dbUrl ? dbUrl.includes("admin") : true
        if (userId && !inValidUrl) {
            axios.patch(dbUrl + `personnel/${userId}/`, userDetails, dbHeaders)
                .catch(error => {
                    options = loadError(error)
                    resolve(null)
                })
        }
        if (userId && !inValidUrl) {
            axios.get(dbUrl + `person-meta-data/?person=${userId}&fields=id`, dbHeaders)
                .then(res => {
                    if (res.data[0].id) {
                        axios.patch(dbUrl + `person-meta-data/${res.data[0].id}/`, userDetails, dbHeaders)
                            // .then(res => {
                            //     resolve(res.data.id)
                            // })
                            .catch(error => {
                                options = loadError(error)
                                resolve(null)
                            })
                    }
                })
        }
    })
}
